import { ConfigurationCustomerResponse } from '@/modules/configurationModule/detail/local-accounting/billable/clients/services/customer-services/configuration-local-accounting-billable-clients-customer-services.dto'
import { StrictNullable } from '@/shared/types/app.types'

export enum ConfigurationLocalAccountingCustomerModalTabIndex {
    BASIC = 0,
    CONTACT_DATA = 1,
    RULES = 2,
    RATES = 3
}

export interface ConfigurationLocalAccountingCustomersModalState {
    client: StrictNullable<ConfigurationCustomerResponse>
    activeTabIndex: number
    actionTitle: string
}
export const initialConfigurationLocalAccountingCustomersModalState =
    (): ConfigurationLocalAccountingCustomersModalState => ({
        client: null,
        activeTabIndex: ConfigurationLocalAccountingCustomerModalTabIndex.BASIC,
        actionTitle: ''
    })
